import React from "react";
var __jsx = React.createElement;
/** Animated placeholder block shown in place of content while it loads. */
export function Skeleton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: "animate-pulse rounded-sds-200 bg-sds-base-secondary ".concat(className)
  });
}